var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ch-Payment_PayPalWrapper",attrs:{"id":_vm.identifier}})])}
var staticRenderFns = []

export { render, staticRenderFns }